<template>
	<div>
		<div class="address_box" v-if="list" v-for="(item,index) in list" >
			<div class="address_boxleft" @click="isbuy? taplist(index) : ''">
				<!-- <input type="radio" class="address_radio"/> -->
        <img class="address_radio" v-if="isbuy" :src="item.checked?'/static/checkdeicon.png' : '/static/checkicon.png'" />
				<div :class="isbuy ? 'address_mesg' : 'address_mesg1' ">
					<div class="address_name">收货人：{{item.addressee}}</div>
					<div class="address_name">手机号码：{{item.mobile}}</div>
					<div class="address_name">收货地址：{{item.province}}{{item.city}}{{item.district}}{{item.address}}</div>
				</div>
			</div>
			<div class="address_boxright" @click="deladdress(item.id)">删除</div>
		</div>
    <div class="page_none" v-else>
      <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
    </div>
    <div class="add_addressnone"></div>
		<div class="add_address" @click="toAddaddress()">新增地址</div>
	</div>
</template>

<script>
	import httper from '../../api/http';
	import {
	  Dialog
	} from 'vant';
	export default{
		data(){
			return{
				lengthX:false,
				list:[],
        addressIndex:0,
        buttonClicked: false, // 防止用户重复点击,默认为false
        isbuy:false,
        buymesg:""
			}
		},
		created() {
			this.request("getAddressList")
      if(this.$route.query.isbuy){
        this.isbuy = true
      }else{
        this.isbuy = false
      }
      if(this.$route.query.buymesg){
        this.buymesg = JSON.parse(this.$route.query.buymesg)
      }
		},
		mounted() {

		},
		methods:{
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
			toAddaddress(){
				let that = this
        if(that.isbuy){
          that.$router.push({
          	path:"/projectAddAddress",
            query:{
              isbuy:true,
              buymesg: JSON.stringify(that.buymesg)
            }
          })
        }else{
          that.$router.push({
          	path:"/projectAddAddress"
          })
        }

			},
			deladdress(addressId){
        let requestData = {
          id: addressId
        }
        let that = this
          Dialog.confirm({
              title: '提示',
              message: '确定删除此地址吗?',
            })
            .then(() => {
              that.request("delAddress",requestData)
            })
            .catch(() => {
              return false;
            });
			},
      taplist(e) {
        let that = this
        var list = this.list
        if (this.buttonClicked) return
        that.buttonClickedFun(1000)
        list.map((item, index2) => item.checked = index2 === Number(e))
        that.list = list
        var addressItem = that.list[Number(e)]
        that.$router.push({
          name: 'projectBuy',
          query: {
            addressItem:JSON.stringify(addressItem) ,
            buymesg: JSON.stringify(that.buymesg)
          }
        })

      },
			//调用接口
			request(type = '', requestData = {}) {
			  let that = this
			  switch (type) {
			    // 获取订单信息列表
			    case 'getAddressList':
			      httper.post('/user/address-list', requestData, res => {
					  if(res.code==0){
						  let lengthX = res.data.length - 20 === 0 //判断列是否20条
						  that.lengthX = lengthX
						  // that.list = [...this.list, ...res.data] //数据拼接,
						  // if (res.data.length > 0) {
						  //   let list = that.list;
						  //   for (let i = 0; i < res.data.length; i++) {
						  //     list.push(res.data[i]);
						  //   }
              res.data.map((item, index) => item.checked = index === that.addressIndex)
						    that.list = res.data
						  //}
					  }else{
						  this.$toast({
						    message: res.message || '系统异常',
						  })
					  }

			      }, true)
			      break
				  //删除地址
				  case 'delAddress':

				    httper.get('/user/del-address', requestData, res => {

				      if(res.code==0){
						  that.$toast({
							  message:'删除成功'
						  })
						  that.request("getAddressList")
					  }else{
						  this.$toast({
						    message: res.message || '系统异常',
						  })
					  }
				    },true)
				    break
			  }
			},
			//查看更多
			// getMore() {
			//   let that = this
			//   that.$toast({
			//     message: '没有更多了'
			//   })
			//   let page = (that.pages) + 1
			//   that.changeNavIndex(that.navIndex, page, false)
			// },
		}
	}
</script>

<style  scoped="scoped">
	body{
		background-color: #F5F5F5;
	}
	.address_box{
		width: calc(100% - 40px);
		margin: 20px 20px 0 20px;
		background-color: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;
	}
	.address_boxleft{
		display: flex;
		align-items: center;

	}
	.address_radio{
		width: 5%;
    height: 15px;
    margin-right: 20px;
	}
	.address_mesg{
		width: 85%;
		margin-right: 10px;
	}
  .address_mesg1{
    width: 100%;
    margin: 10px;
  }
	.address_name{
		font-size: 12px;
		margin-bottom: 5px;
	}
	.address_boxright{
		width: 10%;
		font-size: 12px;
		color: #FD8C00;
	}
	.add_address{
		width: calc(100% - 40px);
		height: 38px;
		border-radius:19px;
		background-color: #FD8C00;
		color: #fff;
		font-size: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		bottom: 0;
		margin:  10px 20px;
	}
  .add_addressnone{
    width: 100%;
    height: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/projectAddressList.vue